import { MapPin, MessageCircle, Mail } from "lucide-react";
import { BUSINESS, waLink } from "../lib/zoco";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#022D24] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 overflow-hidden">
              <img
                src="/brand/zoco-logo.jpg"
                alt="Zoco Fruits"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-display text-4xl tracking-tight">
                Zoco <span className="italic">Fruits</span>
              </span>
              <span className="font-sans-z text-[9px] tracking-[0.32em] uppercase mt-2 text-white/70">
                Fruits &amp; Vegetables Delivery
              </span>
            </div>
          </div>
          <p className="font-sans-z text-sm text-white/70 leading-relaxed max-w-md">
            Frutería selecta en La Cala del Moral. Especialidad en especias,
            frutos secos, café y miel. Producto de cercanía con el oficio del
            mercado de toda la vida.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-sans-z text-[10px] uppercase tracking-[0.3em] font-semibold text-[#7DB7B0] mb-4">
            Visítanos
          </p>
          <p className="font-display text-2xl tracking-tight mb-1">
            {BUSINESS.address}
          </p>
          <p className="font-sans-z text-sm text-white/70 mb-4">
            {BUSINESS.city} · {BUSINESS.region}
          </p>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${BUSINESS.mapsQuery}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-map-link"
            className="inline-flex items-center gap-2 font-sans-z text-[11px] tracking-[0.22em] uppercase font-semibold text-[#7DB7B0] hover:text-white transition-colors"
          >
            <MapPin size={14} strokeWidth={1.8} /> Cómo llegar
          </a>
        </div>

        <div className="md:col-span-4">
          <p className="font-sans-z text-[10px] uppercase tracking-[0.3em] font-semibold text-[#7DB7B0] mb-4">
            Pedidos
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center gap-3 font-display text-2xl md:text-3xl tracking-tight text-white hover:text-[#7DB7B0] transition-colors mb-3"
          >
            <MessageCircle size={20} strokeWidth={1.8} />
            {BUSINESS.whatsappDisplay}
          </a>
          <a
            href={`mailto:${BUSINESS.email}`}
            data-testid="footer-email-link"
            className="inline-flex items-center gap-3 font-sans-z text-sm tracking-wide text-white/80 hover:text-[#7DB7B0] transition-colors break-all"
          >
            <Mail size={16} strokeWidth={1.8} />
            {BUSINESS.email}
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 font-sans-z text-[10px] tracking-[0.22em] uppercase text-white/55">
          <span>© {new Date().getFullYear()} Zoco · Todos los derechos reservados</span>
          <span>Hecho con cariño en La Cala del Moral</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
